
import { Banking, BankAccount } from "../../classes"
const BankAccountModule = {
  namespaced: true,
  state: {
    bankAccounts: []
  },
  mutations: {
    setBankAccounts(state, bankAccounts) {
      state.bankAccounts = bankAccounts || []
    },
    updateBankAccount(state, bankAccount) {
      if (state.bankAccounts) {
        let index = state.bankAccounts.findIndex(i => i.objectId === bankAccount.objectId);
        state.bankAccounts[index] = bankAccount;

        const temp = state.bankAccounts
        state.bankAccounts = []
        state.bankAccounts = temp
      }
    },
    addBankAccounts(state, bankAccount) {
      if (state.bankAccounts && state.bankAccounts.length)
        state.bankAccounts.push(bankAccount)
      else
        state.bankAccounts = [bankAccount]
    },
    removeBankAccount(state, bankAccount) {
      if (state.bankAccounts) {
        let index = state.bankAccounts.findIndex(i => i.objectId === bankAccount.objectId);
        state.bankAccounts.splice(index, 1);
      }
    },
  },
  actions: {
    createBankAccount: async ({ commit }, postData) => {
      try {
        const data = await BankAccount.createBankAccount(postData)
        commit("addBankAccounts", data)
        return data
      } catch (error) {
        throw error
      }
    },
    getBankAccounts: async ({ commit }, projectId) => {
      try {
        const data = await BankAccount.getBankAccounts(projectId)
        commit("setBankAccounts", data)
        return data
      } catch (error) {
        throw error
      }
    },
    updateBankAccount: async ({ commit }, postData) => {
      try {
        const data = await BankAccount.updateBankAccount(postData)
        commit("updateBankAccount", data)
        return data
      } catch (error) {
        throw error
      }
    },
    removeBankAccount: async ({ commit }, bankAccountId) => {
      try {
        const data = await BankAccount.removeBankAccount(bankAccountId)
        commit("removeBankAccount", data)
        return data
      } catch (error) {
        throw error
      }
    },
  },
  getters: {
    getBankAccounts: (state) => state.bankAccounts.map(i => {
      const bank = Banking.getBank(i.bankCode);
      return {
        ...i,
        bank
      };
    })
  },
};
export default BankAccountModule;
